import { Component } from '@verndale/core';
import isEmail from 'validator/lib/isEmail';

class SubscribeForm extends Component {
  setupDefaults() {
    this.dom = {
      formElements: [...this.el.elements],
      errorMessage: this.el.querySelector('.subscribe-alert'),
      successMessage: this.el.querySelector('.thank-you-message'),
      emailInput: this.el.querySelector('input[type="email"]'),
      submitButton: this.el.querySelector('button[type="submit"]')
    };

    this.validateForm();
  }

  addListeners() {
    this.el.addEventListener('submit', this.handleSubmit.bind(this));
    this.dom.formElements.forEach(el => {
      el.addEventListener('focusout', this.validateInput.bind(this));
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.dom.errorMessage.style.display = 'none';
    if (!this.validateForm()) {
      this.dom.errorMessage.style.display = 'block';
      return;
    }

    const form = this.el;
    const formData = new FormData(form);

    const body = {
      FirstName: formData.get('FirstName'),
      LastName: formData.get('LastName'),
      Email: formData.get('Email'),
      Company_Name: formData.get('Company_Name'),
      Job_Title: formData.get('Job_Title'),
      Country: formData.get('Country'),
      Prov_State: formData.get('Prov_State'),
      Postal_ZIP: formData.get('Postal_ZIP'),
      English: formData.get('English'),
      French: formData.get('French'),
      Alumnus: formData.get('Alumnus'),
      Practice: formData.getAll('practice[]'),
      Industry: formData.getAll('industry[]'),
      Consent: formData.get('Consent')
    };

    fetch(form.getAttribute('action'), {
      method: 'POST',
      body: JSON.stringify(body)
    })
      .then(() => {
        this.dom.submitButton.style.display = 'none';
        this.dom.successMessage.style.display = 'block';
      })
      .catch(() => {
        console.log('error');
      });
  }

  validateInput(e) {
    const { target } = e;
    const errorMessage = e.target.parentNode.querySelector('.form-error');
    let isValid = true;

    isValid = target.checkValidity();

    if (target.type === 'email') {
      isValid = isValid && isEmail(target.value);
    }

    if (isValid) {
      target.classList.remove('is-invalid-input');
      if (errorMessage) {
        errorMessage.classList.remove('is-visible');
      }
    } else {
      target.classList.add('is-invalid-input');
      if (errorMessage) {
        errorMessage.classList.add('is-visible');
      }
    }
    this.validateForm();
  }

  validateForm() {
    if (this.el.checkValidity() && isEmail(this.dom.emailInput.value)) {
      this.dom.submitButton.removeAttribute('disabled');
      return true;
    }

    this.dom.submitButton.setAttribute('disabled', '');
    return false;
  }
}

export default SubscribeForm;
